(function () {
    'use strict';

    angular
        .module('ib-new-seat-map-module')
        .controller('ibOldFlightMapController', ibOldFlightMapController);

    ibOldFlightMapController.$inject = ['$scope', '$timeout', '$filter', '$rootScope', '$window', 'AncillariesConstants', 'AncillariesUtilsService', 'ModalServiceAncillaries', '$compile', 'CommonsAncillariesService'];
    function ibOldFlightMapController ($scope, $timeout, $filter, $rootScope, $window, AncillariesConstants, AncillariesUtilsService, ModalServiceAncillaries, $compile, CommonsAncillariesService) { //currentPassenger && model comes from directives input

        const vm = this;
        vm.seatInfoSelected;
        vm.isInfiniteScroll = false;
        vm.tooltipOpened = false;
        vm.isMobile = AncillariesUtilsService.isTouchDevice();
        vm.isAllowed = isAllowed;
        vm.stateSeats = stateSeats;
        vm.hoverPreview = hoverPreview;
        vm.endHoverPreview = endHoverPreview;
        vm.isEmergency = isEmergency;
        vm.tooltipTouch = tooltipTouch;
        vm.change = change;
        vm.isDisabledOccupation = isDisabledOccupation;
        vm.scrollToSeat = scrollToSeat;
        vm.createFirstId = createFirstId;
        vm.isWing = isWing;
        vm.$onInit = activate;



        $scope.$on('scrollToSeat', (event, arg) => {
            scrollToSeat(vm.currentPassenger.currentSeat);
        });


        vm.eventTooltipOpened = $rootScope.$on('tooltipOpened', (e, data) => {
            vm.tooltipOpened = data;
        });


        function activate () {
            let isDisabled = false, i = 0;
            while (!isDisabled && i < vm.passengers?.length) {
                if (vm.passengers[i].initialSeat.row !== '' || vm.passengers[i].initialSeat.column !== '') {
                    isDisabled = true;
                }
                i++;
            }

            vm.isInfiniteScroll = isDisabled;
            scrollToSeat(vm.currentPassenger?.currentSeat);
        }

        /**
         * Scroll to seat of current passenger in view
         * @param {Object} seat Seat information
         */
        function scrollToSeat (seat) {
            let auxSeatPreAssigned;
            let columnPreAssigned;
            const seatPreAssigned = seat;
            const id = '#cabins-' + seatPreAssigned?.cabinIndex + '-row-' + seatPreAssigned.rowIndex + '-seat-' + seatPreAssigned.columnIndex;
            $timeout(() => {
                if (id !== null) {
                    auxSeatPreAssigned = angular.element(id);
                    if(auxSeatPreAssigned.length === 0) {
                        auxSeatPreAssigned = angular.element(createFirstId(seatPreAssigned.cabinIndex,
                            vm.seatsModel.cabins));
                    }
                    columnPreAssigned = angular.element(auxSeatPreAssigned).parent().parent();
                    angular.element('#scroll-container').scrollToElementAnimated(columnPreAssigned, 50, 2000);
                }
            });
        }

        /**
         * Create first ID
         *
         */
        function createFirstId (index, cabins) {
            let founded=false, i=0,j=0,k=0,rowIndex=0,columnIndex=0, indexColumn=0;

            while(founded === false) {
                if(cabins[i].enabled) {
                    for (j=0; j<cabins[i].columns.length; j++) {
                        if(cabins[i].columns[j].name !=='') {
                            rowIndex=j;
                            j=cabins[i].columns.length;
                        }
                    }
                    for (j=0; j<cabins[i].seatMap.length; j++) {
                        indexColumn =j;
                        for (k=0; k<cabins[i].seatMap[indexColumn].rowSeats.length; k++) {
                            if(cabins[i].seatMap[indexColumn].rowSeats[k].column !==' ') {
                                columnIndex=k;
                                k=cabins[i].seatMap[indexColumn].rowSeats.length;
                                j=cabins[i].seatMap.length;
                            }
                        }
                    }
                    founded=true;
                }
                i++;
            }
            return '#cabins-' + index + '-row-' + rowIndex+ '-seat-' + columnIndex;
        }

        /**
         * Check if seat is allowed for current user
         * @param {Array} seatAllowed Array of passengers authorized for seat
         */
        function isAllowed (seatAllowed) {
            let isAllowed = false;
            if (seatAllowed) {
                isAllowed = seatAllowed.indexOf('' + vm.currentPassenger?.id) !== -1;
            }
            return isAllowed;
        }

        /**
         * Return state of seat
         * @param {Object} seat Seat information
         * @param {String} rowFeatures Features
         * @param {String} seatIndex Index of seat
         * @param {String} rowSeats  Row of seat
         */
        function stateSeats (seat, rowFeatures, seatIndex, rowSeats) {
            let state;
            switch (seat.type) {
                    case AncillariesConstants.SeatTypes.seat: state = generateSeatClass(seat); break;
                    case AncillariesConstants.SeatTypes.gap: rowFeatures.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1
                    && (seatIndex === 0 || seatIndex === rowSeats.length - 1) ? state = 'ib-map__column ib-map__column--gap--emergency'
                        : state = 'ib-map__column ib-map__column--gap  ib-map__column--unfocused'; break;
            }
            return state;
        }


        /**
         * Return class of seat
         * @param {*} seat
         */
        function generateSeatClass (seat) {
            let state;
            switch (seat.occupation) {
                    case AncillariesConstants.SEAT_OCCUPATIONS.free: state = generateFreeSeatClass(seat); break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.selection: state = 'ib-map__column ib-map__column--selection'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.blocked: state = 'ib-map__column ib-map__column--occupied'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.occupied: state = 'ib-map__column ib-map__column--occupied'; break;
                    case AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser: state = 'ib-map__column ib-map__column--selected-other-passenger'; break;
                    default: state = 'ib-map__column ib-map__column--free'; break;
            }
            return state;
        }



        function generateFreeSeatClass (seat) {
            let state;
            if (vm.isAllowed(seat.passengersAllowed)) {
                state = 'ib-map__column ib-map__column--free';
                if (seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1) {
                    state = 'ib-map__column ib-map__column--emergency';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) === -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.extraSize) !== -1) {
                    state = 'ib-map__column ib-map__column--comfort ';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.infant) !== -1) {
                    state = 'ib-map__column ib-map__column--infant';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) === -1) {
                    state = 'ib-map__column ib-map__column--promo';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(AncillariesConstants.SeatFeatures.infant) !== -1) {
                    state = 'ib-map__column ib-map__column--infant';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.upfront) !== -1) {
                    state = 'ib-map__column ib-map__column--upfront';
                } if (seat.features.indexOf(AncillariesConstants.SeatFeatures.mobility) !== -1) {
                    state = 'ib-map__column ib-map__column--handicap';
                }
            } else {
                state = 'ib-map__column ib-map__column--occupied';
            }
            return state;
        }



        /**
         * Check if seat is emergency
         * @param {Array} rowFeatures Features of seat
         */
        function isEmergency (rowFeatures) {
            return rowFeatures.indexOf(AncillariesConstants.SeatFeatures.emergencyExit) !== -1;
        }

        /**
         * Check if seat is wing
         * @param {Array} rowFeatures Features of seat
         */
        function isWing (rowFeatures) {
            return rowFeatures.indexOf(AncillariesConstants.SeatFeatures.wing) !== -1;
        }

        /**
         * Change seat of passenger
         * @param {*} seat
         * @param {*} cabinIndex
         * @param {*} rowIndex
         * @param {*} columnIndex
         */
        function change (seat, cabinIndex, rowIndex, columnIndex) {

            let currentCabin, currentRow, currentColumn;
            if (seat.occupation === AncillariesConstants.SEAT_OCCUPATIONS.selection) {
                const modalMessage = getModalMessage(seat.modalMessages);
                if (modalMessage !== null) {
                    const modalType = getModalType(modalMessage.type);
                    ModalServiceAncillaries.openFeatureModal(modalType.templateUrl, modalType.blocked, modalMessage.message, modalType.class).result.then(accept, () => {
                        vm.tooltipOpened = false;
                        currentCabin = vm.currentPassenger.currentSeat.cabinIndex;
                        currentRow = vm.currentPassenger.currentSeat.rowIndex;
                        currentColumn = vm.currentPassenger.currentSeat.columnIndex;
                        vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation = AncillariesConstants.SEAT_OCCUPATIONS.free;
                        vm.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = AncillariesConstants.SEAT_OCCUPATIONS.selection;
                    });
                } else {
                    if (!vm.isMobile) {
                        changeSeat(cabinIndex, rowIndex, columnIndex);
                    }
                }
            } else {
                const $tooltip = angular.element('.ib-map-tooltip');
                $tooltip.css('display', 'none');
                vm.tooltipOpened = false;
            }

            function accept () {
                vm.tooltipOpened = false;
                changeSeat(cabinIndex, rowIndex, columnIndex);

            }

        }

        /**
         * Change seat of user
         * @param {Integer} cabinIndex
         * @param {Integer} rowIndex
         * @param {Integer} columnIndex
         */
        function deleteSeatSelection (cabinIndex, rowIndex, columnIndex) {

            const currentCabin = vm.currentPassenger.currentSeat.cabinIndex;
            const currentRow = vm.currentPassenger.currentSeat.rowIndex;
            const currentColumn = vm.currentPassenger.currentSeat.columnIndex;
            vm.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = AncillariesConstants.SEAT_OCCUPATIONS.free;
            vm.currentPassenger.currentSeat.row = '';
            vm.currentPassenger.currentSeat.column = '';
            vm.currentPassenger.currentSeat.seatType = '';
            vm.currentPassenger.currentSeat.seatTypeDescription = '';
            vm.currentPassenger.seatPrice = undefined;
            vm.currentPassenger.seatPriceFormatted = '--';
            $scope.$emit('deleteSeatSelection', vm.currentPassenger.id);
        }

        /**
         * Change seat of user
         * @param {Integer} cabinIndex
         * @param {Integer} rowIndex
         * @param {Integer} columnIndex
         */
        function changeSeat (cabinIndex, rowIndex, columnIndex) {

            const currentCabin = vm.currentPassenger.currentSeat.cabinIndex;
            const currentRow = vm.currentPassenger.currentSeat.rowIndex;
            const currentColumn = vm.currentPassenger.currentSeat.columnIndex;
            if (currentCabin !== cabinIndex || currentRow !== rowIndex || currentColumn !== columnIndex) {
                vm.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = AncillariesConstants.SEAT_OCCUPATIONS.free;
            }
            vm.currentPassenger.currentSeat.cabinIndex = cabinIndex;
            vm.currentPassenger.currentSeat.rowIndex = rowIndex;
            vm.currentPassenger.currentSeat.columnIndex = columnIndex;
            vm.currentPassenger.currentSeat.row = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].row;
            vm.currentPassenger.currentSeat.column = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].column;
            vm.currentPassenger.currentSeat.originalType = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].originalType;
            vm.currentPassenger.currentSeat.seatType = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatType;
            vm.currentPassenger.currentSeat.seatTypeDescription = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeDescription;
            vm.currentPassenger.currentSeat.seatTypeMessasge = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeMessasge;
            vm.currentPassenger.seatPrice = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].passengersPrice[vm.currentPassenger.id];
            vm.currentPassenger.seatPriceFormatted = vm.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].passengersPriceLabels[vm.currentPassenger.id];
            $scope.$emit('newSeatChange', {
                id: vm.currentPassenger.id,
                seat: {
                    row: vm.currentPassenger.currentSeat.row,
                    column: vm.currentPassenger.currentSeat.column,
                    cabinIndex: cabinIndex,
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                },
                price: vm.currentPassenger.seatPrice,
                priceFormatted: vm.currentPassenger.seatPriceFormatted,
                seatTypeDescription: vm.currentPassenger.currentSeat.seatTypeDescription,
                seatType: vm.currentPassenger.currentSeat.seatType,
                originalType: vm.currentPassenger.currentSeat.originalType,
                seatTypeMessasge: vm.currentPassenger.currentSeat.seatTypeMessasge
            });
        }


        /**
        * Open toolTip when click on seat in mobile
        * @param {Object} seat
        * @param {String} cabinIndex
        * @param {String} rowIndex
        * @param {String} seatIndex
        * @param {Object} event
        */
        function tooltipTouch (seat, cabinIndex, rowIndex, seatIndex, event) {
            if (vm.isAllowed(seat.passengersAllowed)) {
                if (!isDisabledOccupation(seat.occupation)) {
                    buildTooltipTouch(seat, cabinIndex, rowIndex, seatIndex, event);
                }
            }
        }

        /**
        * Preview seat and price on passenger
        * @param {Object} seat
        */
        function hoverPreview (seat, event) {
            if(!vm.isMobile &&  seat.passengersAllowed.includes(vm.currentPassenger.id.toString()) && seat.occupation === 'FREE') {
                const currentPassengerSeat = {
                    row: vm.currentPassenger.currentSeat.row ,
                    column: vm.currentPassenger.currentSeat.column,
                    seatPrice: vm.currentPassenger.seatPrice,
                    seatPriceFormatted: vm.currentPassenger.seatPriceFormatted,
                    occupation: seat.occupation,
                    seat: seat
                };
                vm.currentPassengerSeat = currentPassengerSeat;

                vm.currentPassenger.currentSeat.row = seat.row;
                vm.currentPassenger.currentSeat.column = seat.column;
                vm.currentPassenger.seatPrice =   seat.passengersPrice[vm.currentPassenger.id];
                vm.currentPassenger.seatPriceFormatted =   seat.passengersPriceLabels[vm.currentPassenger.id];
                seat.occupation = 'SELECTION';
            }
        }

        /**
        * End preview seat and price on passenger
        * @param {Object} seat
        */
        function endHoverPreview (seat, event) {

            if(!vm.isMobile && vm.currentPassengerSeat && seat.row === vm.currentPassengerSeat.seat.row && seat.column === vm.currentPassengerSeat.seat.column) {
                vm.currentPassenger.currentSeat.row = vm.currentPassengerSeat.row;
                vm.currentPassenger.currentSeat.column = vm.currentPassengerSeat.column;
                vm.currentPassenger.seatPrice = vm.currentPassengerSeat.seatPrice;
                vm.currentPassenger.seatPriceFormatted = vm.currentPassengerSeat.seatPriceFormatted;
                seat.occupation =  vm.currentPassengerSeat.occupation;
                vm.currentPassengerSeat = undefined;
            }

        }


        /**
         * Check if seat is disable
         * @param {String} occupation State of seat
         */
        function isDisabledOccupation (occupation) {
            return occupation === AncillariesConstants.SEAT_OCCUPATIONS.blocked || occupation === AncillariesConstants.SEAT_OCCUPATIONS.occupied;
        }

        /**
         * Generate tooltip of seat selected and added to view.
         * @param {Object} seat Seat information
         * @param {Integer} cabinIndex Number of cabin index of seat
         * @param {Integer} rowIndex Number of row
         * @param {Integer} seatIndex Number of seat
         * @param {Object} event Event
         */
        function buildTooltipTouch (seat, cabinIndex, rowIndex, seatIndex, event) {

            seat.price = getPricePassenger(seat, vm.currentPassenger.id);
            seat.selectable = vm.currentPassenger.issuedSeat === undefined;

            ModalServiceAncillaries.openSelectSeatModal({
                seat: seat, seatViewInfo: vm.seatViewInfo,
                currentPassenger: vm.currentPassenger,
                seatOccupation: vm.currentPassengerSeat ? vm.currentPassengerSeat.occupation : seat.occupation
            })
                .result.then((selection)=>{
                    if(selection) {
                        seat.occupation = 'SELECTION';
                        seat.selectable = true;
                        changeSeat(cabinIndex, rowIndex, seatIndex);
                    } else {
                        seat.occupation = 'FREE';
                        deleteSeatSelection(cabinIndex, rowIndex, seatIndex);
                    }
                },
                (reject) => {});

        }


        /**
         * Return price for passenger in seat map
         * @param {Object} seat Information passenger seat
         * @param {Integer} idPassenger Id of passenger for get price
         */
        function getPricePassenger (seat, idPassenger) {
            return seat.passengersPriceLabels[idPassenger];
        }


        /**
         * Return message of seat returned by service
         * @param {Object} modalMessages
         */
        function getModalMessage (modalMessages) {
            let found = false, i = 0, modalMessage = null;
            while (!found && i < modalMessages.length) {
                if (modalMessages[i].passengers.indexOf('' + vm.currentPassenger.id) !== -1) {
                    found = true;
                    modalMessage = { message: modalMessages[i].message, type: modalMessages[i].type };
                }
                i++;
            }
            return modalMessage;
        }

        /**
         * Return type modal
         * @param {String} modalType
         */
        function getModalType (modalType) {
            let modal = {};
            switch (modalType) {
                    case AncillariesConstants.SeatModalTypes.disclaimer: modal = { templateUrl: 'ib-modal-map-seats-emergency.html', blocked: true, class: 'ib-modals ib-modals--sm' }; break;
                    default: modal = { templateUrl: 'ib-modal-seat-map-warning.html', blocked: false, class: 'ib-modals ib-modals--sm' };
            }
            return modal;
        }
    }
})();
